import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Issue, IssueItem } from '../../issue/classes';
import { NewsfeedNotificationObservables } from '../globals';
import { NewsfeedService } from '../services/newsfeed.service';

@Pipe({
  name: 'newsfeedObservablePreview'
})
export class NewsfeedObservablePreviewPipe implements PipeTransform {

  constructor(private _newsfeedService: NewsfeedService) { }

  transform(identifier: string, observable: number): Observable<string> {
    return this._newsfeedService.getAuditStatus(observable, identifier).pipe(map((x: any) => {
      switch (observable) {
        case NewsfeedNotificationObservables.IssueChange:
        case NewsfeedNotificationObservables.IssueCreation:
        case NewsfeedNotificationObservables.IssueDeletion:
          return [(x as Issue).issuenumber, (x as Issue).issuetitle].filter(x => x ? true : false).join(' ');

        case NewsfeedNotificationObservables.IssueItemChange:
        case NewsfeedNotificationObservables.IssueItemCreation:
        case NewsfeedNotificationObservables.IssueItemDeletion:
          return [(x as IssueItem).itemname].filter(x => x ? true : false).join(' ');
      }
      return null;
    }));
  }

}
